import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Button } from "../../../common";
import MarkdownWrapper from "../../../common/MarkdownWrapper";
import { QuickRecapContent } from "../../../../types/newtypes";
import { Award } from "lucide-react";

interface QuickRecapPreviewProps {
  content: QuickRecapContent;
  onCompleted?: () => void;
  onCardStateChange?: (isCompleted: boolean, canProceed: boolean) => void;
}

const QuickRecapPreview: React.FC<QuickRecapPreviewProps> = ({
  content,
  onCompleted,
  onCardStateChange,
}) => {
  const navigate = useNavigate();

  const handleViewCertificate = () => {
    navigate("/certificates");
  };

  return (
    <div className="w-full">
      {/* Main Title */}
      <Typography variant="h4" weight="bold" className="mb-4">
        {content?.slide_title}
      </Typography>

      {/* Intro Text */}
      <Typography variant="p" className="!text-base mb-6">
        {content?.intro_text}
      </Typography>

      {/* Section Title */}
      <Typography variant="h5" weight="bold" className="mb-4">
        {content?.title}
      </Typography>

      <Typography variant="h6" weight="bold" className="mb-2">
        {content?.recap_label || "Your key takeaways are:"}
      </Typography>

      {/* Recap Points List */}
      <div className="space-y-2">
        {content?.points?.map((point, index) => (
          <div key={index} className="flex gap-2 items-start">
            <Typography
              variant="span"
              weight="medium"
              className="text-gray-900 flex-shrink-0 !text-sm"
            >
              {index + 1}.
            </Typography>
            <div className="flex-1 text-sm">
              <MarkdownWrapper content={point} />
            </div>
          </div>
        ))}
      </div>

      {content?.additional_text && (
        <div className="mt-4">
          <MarkdownWrapper content={content.additional_text} />
        </div>
      )}

      {/* Certificate Link Button */}
      {content?.show_certificate_link && (
        <div className="mt-6 flex justify-center">
          <Button
            variant="filled"
            label="View Your Certificate"
            onClick={handleViewCertificate}
            startIcon={<Award className="w-5 h-5" />}
          />
        </div>
      )}
    </div>
  );
};

export default QuickRecapPreview;
